// @core/api/endpoints/secret/rotate_encryption_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EncryptionKeyResponse,
  RotateEncryptionKeyRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Rotate encryption key
 * Creates a new version of the encryption key. New encryptions use the latest version. Existing ciphertexts remain decryptable with older versions (subject to min_decryption_version).
 */
export async function RotateEncryptionKey(
  engine_id: string,
  key_name: string,
  data: RotateEncryptionKeyRequest,
  options?: RequestOptions
): Promise<EncryptionKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/keys/:key_name/rotate`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.post<EncryptionKeyResponse>(requestPath, data, requestOptions);
}
